var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',[_c('p',{staticClass:"copyright"},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" by "),_c('a',{attrs:{"href":"https://nagorik.tech/"}},[_vm._v("Nagorik Tech")]),_vm._v(". ")])])}
var staticRenderFns = []

export { render, staticRenderFns }